import React from 'react';
const testimonials = [{
  name: 'Marco G.',
  role: 'Allenatore U16',
  city: 'Milano',
  text: 'Ho risparmiato ore di pianificazione! I miei ragazzi sono molto più motivati e i risultati in campionato si vedono subito.',
  stars: 5
}, {
  name: 'Luca S.',
  role: 'Responsabile Tecnico',
  city: 'Roma',
  text: 'Finalmente un kit completo. Le progressioni tecniche sono perfette, soprattutto per chi allena le giovanili.',
  stars: 5
}, {
  name: 'Valentina R.',
  role: 'Allenatrice Serie B',
  city: 'Torino',
  text: 'La Dirigente mi ha fatto i complimenti per il progetto tecnico presentato. Non sa che ho fatto tutto in 5 minuti grazie a EDULABS!',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-222">
      <div className="max-w-5xl mx-auto" data-id="element-223">
        <div className="text-center mb-14" data-id="element-224">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-225">
            Cosa dicono gli allenatori
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-226">
            Oltre <span className="text-primary font-bold" data-id="element-227">5.000 tecnici</span>{' '}
            hanno già scelto Pallamano Pronta
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-228">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-229">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-230"></div>

              {/* Stars */}
              <div className="flex items-center gap-0.5 relative z-10" data-id="element-231">
                {Array.from({
              length: t.stars
            }).map((_, j) => <span key={j} className="text-secondary text-lg" data-id="element-232">
                    ⭐
                  </span>)}
              </div>

              {/* Quote */}
              <p className="text-text-main text-base leading-relaxed font-medium relative z-10 flex-1" data-id="element-233">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light/50 relative z-10" data-id="element-234">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-235">
                  <span className="text-sm font-bold text-primary" data-id="element-236">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-237">
                  <p className="text-text-main font-bold text-sm" data-id="element-238">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-239">
                    {t.role} · {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}